import {ComparisonTableLazy} from 'app/components/comparisonTable/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineComparisonTable(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-comparison-table')) {
        return;
    }

    customElements.define(
        'gem-comparison-table',
        class extends WebComponentLoader {
            reactLazyComponent = ComparisonTableLazy;
        },
    );
}
